export const SET_pautaS = "PESSOAS_FISICA/SET_pautaS";
export const SET_pauta = "PESSOAS_FISICA/SET_pauta";
export const SET_PAGINATION = "PESSOAS_FISICA/SET_PAGINATION";
